import { render, staticRenderFns } from "./DatabaseCompaniesView.vue?vue&type=template&id=0932c43d&"
import script from "./DatabaseCompaniesView.vue?vue&type=script&lang=ts&"
export * from "./DatabaseCompaniesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports